import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import * as UserDataConfig from '../../pages/user-details/config/user-data.config';
import { Subscription } from 'rxjs';
import { ModalScroll } from 'src/app/shared';
import { UtilService, SERVICE_END_POINT } from 'src/app/shared';

@Component({
  selector: 'app-product-tiles',
  templateUrl: './product-tiles.component.html',
  styleUrls: ['./product-tiles.component.scss']
})
export class ProductTilesComponent implements OnInit {

  @Input() product;
  public userInputDetail;
  @Input() fundingSource;
  @Input() parent: UntypedFormGroup;
  @Input() widthSize = '30';
  @Input() isProductSelected = false;
  @Input() noOfProduct: number;
  @Input() prodID: string;
  @Output() onProductSelectClickHandler: EventEmitter<any> = new EventEmitter<any>();

  updatedProduct: object;
  docAvalable = true;
  public CMSData;
  //userdatacong:userdata;
  private subscriptn: Subscription;
  private imgURL;
  // private element: HTMLElement;
  //@ViewChild('check1', { static: true }) checkBoxFoc : ElementRef
  constructor(private btnFocusOnModalClose: ModalScroll, private utilService: UtilService) {  }

  ngOnInit() {
    this.GetCMSDataService();
    this.userInputDetail = UserDataConfig.ElementsConfig.productChoice.products.filter(p => p.productCode === this.product.productCode)[0];          
    this.updateDocumentLink();
    //this.focusOnbtn();
  }

  ngOndestroy() {
    this.subscriptn.unsubscribe();

  }


  updateDocumentLink() {
    this.updatedProduct = this.product;
    const keyFeature: any[] = this.product.documentLink.find(p => p.key === 'keyFeatures');
    this.updatedProduct['documentLink'].forEach(element => {
      if (element.key === "keyFeatures") {
        const urlSizeArray = element.urlArray.find(u => u.fundingSource === this.fundingSource);
        element.size = urlSizeArray.size;
        element.url = urlSizeArray.url;
        if (element.size !== '') {
          this.docAvalable = false;
        }
      }
    });
  }

  onProductSelect(value: boolean, productname: string, code: string) {
    this.onProductSelectClickHandler.emit({ value, productname, code });
  }

  getID(id_value) {
    let s;
    s  =  id_value.replace(/\s/g,  '');
    s = s.charAt(0).toLowerCase() + s.substr(1);
    return s;
  }

  onImageClick(imagelink) {
    window.open(imagelink, '_blank');

  }

  /** Code block for CMS */
GetCMSDataService() {
  const URL = SERVICE_END_POINT.higherEnvironment.CMS_YourProductChoice;
  //console.log('original value = ' );
  this.utilService.getCMSData(URL)
  .subscribe(res => {
    //console.log('2 GetCMSDataService => ', res);
    this.CMSData = res;
    // if (this.CMSData) {
      // switch (this.userInputDetail.productCode) {
      //   /** Pension Annuity */
      //   case 'C':
      //     this.userInputDetail.imageName = this.CMSData.imageUrl_PensionAnnuityProductIcon;
      //     break;
          
      //   /** FTRP */
      //   case 'H':
      //     this.userInputDetail.imageName = this.CMSData.imageUrl_FTRPProductIcon;
      //     break;
      //   /** CORP */
      //   case 'G':
      //     this.userInputDetail.imageName = this.CMSData.imageUrl_CORPProductIcon;
      //     break;
      // }
     // this.userInputDetail['buttonConfig'].label = this.CMSData.commonBlock.string_NextCTALabel;

      //console.log('changed value = ', this.userInputDetail );
     // }
  });
}
/** End of code block for CMS */

}
